import React from 'react';
import { AlertTriangleIcon, SparklesIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full bg-stone-100 py-16 md:py-24" data-id="element-464">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-465">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-466">
          <div className="bg-white rounded-xl p-8 shadow-lg" data-id="element-467">
            <div className="flex items-center gap-3 mb-4" data-id="element-468">
              <AlertTriangleIcon className="w-8 h-8 text-red-600" data-id="element-469" />
              <h3 className="text-2xl font-bold text-stone-900" data-id="element-470">The Problem</h3>
            </div>
            <p className="text-lg text-stone-700 mb-4 leading-relaxed" data-id="element-471">
              Modern medicine treats the symptom — not the cause. So you feel
              temporary relief… and then the problem returns.
            </p>
            <div className="space-y-2 text-stone-600" data-id="element-472">
              <p data-id="element-473">❌ Sleeping pills don't fix stress.</p>
              <p data-id="element-474">❌ Painkillers don't heal inflammation.</p>
              <p data-id="element-475">❌ Cold medicine doesn't support immunity.</p>
            </div>
            <p className="text-lg text-stone-700 mt-4 font-semibold" data-id="element-476">
              That's why people stay stuck, sick, exhausted, and dependent on
              medication.
            </p>
          </div>
          <div className="bg-emerald-700 text-white rounded-xl p-8 shadow-lg" data-id="element-477">
            <div className="flex items-center gap-3 mb-4" data-id="element-478">
              <SparklesIcon className="w-8 h-8 text-emerald-200" data-id="element-479" />
              <h3 className="text-2xl font-bold" data-id="element-480">The Solution</h3>
            </div>
            <p className="text-lg mb-4 leading-relaxed" data-id="element-481">
              Herbal remedies address the root — so the body actually heals.
              When you give your body nutrients, enzymes, antioxidants,
              anti-inflammatory herbs and immune-supporting compounds…
            </p>
            <div className="space-y-2" data-id="element-482">
              <p data-id="element-483">✅ symptoms fade</p>
              <p data-id="element-484">✅ energy returns</p>
              <p data-id="element-485">✅ sleep deepens</p>
              <p data-id="element-486">✅ digestion settles</p>
              <p data-id="element-487">✅ inflammation reduces</p>
            </div>
            <p className="text-lg mt-4 font-semibold" data-id="element-488">
              Your body does the healing. You just supply the tools.
            </p>
            <p className="text-sm mt-4 text-emerald-100" data-id="element-489">
              Unlike synthetic drugs, herbal remedies work with your body, not
              against it.
            </p>
          </div>
        </div>
      </div>
    </section>;
}